export default "__VITE_ASSET__dAeQgekO__"